export enum InternalAdminRole {
  MANUFACTURING_ADMIN = 'manufacturing-admin',
  SALES_ADMIN = 'sales-admin',
  SUPER_ADMIN = 'super-admin',
  _NONE = 'non-admin'
}

export const INTERNAL_ADMIN_ROLE_TO_LABEL: Record<InternalAdminRole, string> = {
  [InternalAdminRole.MANUFACTURING_ADMIN]: 'Production Admin',
  [InternalAdminRole.SALES_ADMIN]: 'Sales Admin',
  [InternalAdminRole.SUPER_ADMIN]: 'Super Admin',
  [InternalAdminRole._NONE]: 'None'
};

export const FULL_ACCESS = '*';

export const INSUFFICIENT_PERMISSIONS_MESSAGE = 'It looks like you don’t have access to this area. If you think this is a mistake, get in touch with your manager.';